import React from 'react';
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  Typography,
  Divider,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/CloseRounded';
import infoIcon from '@src/assets/icons/info.png';
import WarningOrangeImg from '@src/assets/icons/warning-orange.svg';

import { StyledDialog } from './index.style';

// TODO: refactor as header - content - action instead of using props like this
const NotificationDialog = ({
  name,
  title,
  hiddenIcon,
  removePaddingAction,
  variant = 'info', // info | warning
  open,
  width,
  contentComponent,
  actionComponent,
  onClose,
  dialogDevice,
  closeIcon,
}) => {
  const renderIcon = () => {
    switch (variant) {
      // TODO: Update icon info
      case 'info':
        return infoIcon;
      case 'warning':
        return WarningOrangeImg;
      default:
        return null;
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    onClose(name);
  };

  return (
    <StyledDialog
      dialogDevice={dialogDevice}
      key={name}
      open={open}
      width={width}
      onClose={handleClose}
      removePaddingAction={removePaddingAction}
    >
      <div className="dialog-wrapper">
        <div className="content-wrapper">
          <DialogTitle classes={{ root: 'dialog-title' }}>
            {!hiddenIcon && (
              <div>
                <img src={renderIcon()} alt="icon" className="icon" />
              </div>
            )}
            <Typography className="title">{title}</Typography>
            {closeIcon && (
              <IconButton className="close-icon" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            )}
          </DialogTitle>
          <Divider />
          <DialogContent classes={{ root: 'dialog-content' }}>
            {contentComponent}
          </DialogContent>
          {actionComponent && (
            <DialogActions classes={{ root: 'dialog-action' }}>
              {actionComponent}
            </DialogActions>
          )}
        </div>
      </div>
    </StyledDialog>
  );
};

export default NotificationDialog;
